var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dynaError } from "dyna-error";
export const isURLReachable = (url, method // This method bypasses the CORS restrictions
) => __awaiter(void 0, void 0, void 0, function* () {
    return method === "fetch-method"
        ? isURLReachableByFetchMethod(url)
        : isURLReachableByScriptElement(url);
});
const isURLReachableByFetchMethod = (url) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(url);
        if (response.ok) {
            return {
                ok: true,
                status: response.status,
            };
        }
        else {
            return {
                ok: false,
                status: response.status,
            };
        }
    }
    catch (e) {
        const error = dynaError(e);
        return {
            ok: false,
            status: -1,
            networkError: error,
        };
    }
});
const isURLReachableByScriptElement = (url) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = () => {
            var _a;
            resolve({
                ok: true,
                status: 200,
            });
            // Remove the script element after it has been loaded.
            (_a = script.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(script);
        };
        script.onerror = (error) => {
            var _a;
            resolve({
                ok: false,
                status: -1,
                networkError: error,
            });
            // Remove the script element if an error occurs.
            (_a = script.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(script);
        };
        document.head.appendChild(script);
    });
});
